export default __webpack_public_path__ + "static/media/favicon.6473ed04.ico";